/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_Changed_During_LoadInputs */

const en_ledger_error_changed_during_load = /** @type {(inputs: Ledger_Error_Changed_During_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The source query changed while accounts were loading, try again`)
};

const nl_ledger_error_changed_during_load = /** @type {(inputs: Ledger_Error_Changed_During_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De bronquery is gewijzigd tijdens het laden, probeer het opnieuw`)
};

/**
* | output |
* | --- |
* | "The source query changed while accounts were loading, try again" |
*
* @param {Ledger_Error_Changed_During_LoadInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_changed_during_load = /** @type {((inputs?: Ledger_Error_Changed_During_LoadInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_Changed_During_LoadInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_changed_during_load(inputs)
	return en_ledger_error_changed_during_load(inputs)
});